import { GridPaginationModel } from '@mui/x-data-grid-pro';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { bffClient } from 'api/apollo';
import { GET_JAMF_ASSETS_V2, V2FindAndCountAssets } from 'api/apollo/queries/v2/assets';

export const getJamfAssets = createAsyncThunk(
  'jamf/assets/getJamfAssets',
  async (params: {
    organizationId: string;
    paginationModel: GridPaginationModel;
  }) => {
    const { organizationId, paginationModel } = params;
    const { page, pageSize } = paginationModel;

    // Calculate pagination parameters
    const skip = page * pageSize;
    const take = pageSize;

    // First get the count of all assets with jamfId
    const countResponse = await bffClient.query({
      query: V2FindAndCountAssets,
      variables: {
        where: {
          organizationId: { equals: organizationId },
          jamfId: { not: null }
        }
      },
      fetchPolicy: 'network-only'
    });

    const {count} = countResponse.data.v2FindAndCountAssets;

    // Then get the assets for the current page
    const response = await bffClient.query({
      query: GET_JAMF_ASSETS_V2,
      variables: {
        organizationId,
        skip,
        take
      },
      fetchPolicy: 'network-only'
    });

    const jamfAssets = response.data.v2FindAssets;
    
    return {
      assets: jamfAssets,
      count
    };
  }
); 
